import styled from '@emotion/styled';

export const LexiconSettingsContainerStyled = styled.div`
  display: block;
`;
